/**
 * True only on the real production candidate-facing host (talentcrux.ai).
 * Deliberately hostname-based, not NODE_ENV: CRA's `npm run build` always sets
 * NODE_ENV=production for both the dev deploy (dev.talentcrux.ai) and the real
 * prod deploy (talentcrux.ai) — see .github/workflows/deploy-dev.yml — so
 * NODE_ENV cannot distinguish them. Used to gate anything that must never be
 * reachable by a real candidate (e.g. E2E test-only bypass buttons) while still
 * working on localhost/dev where testing happens.
 */
export function isProdHost() {
  if (typeof window === 'undefined') return false;
  return /^(www\.)?talentcrux\.ai$/i.test(window.location.hostname);
}
